import { Typography } from '@mui/material';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { PortalList } from 'containers/user/Portal/PortalListingType';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ROOT_NAVIGATION } from 'routes/paths';
import Iconify from '../../../components/Iconify';
interface OwnProps {
  currentPortalId?: string;
  portals: PortalList[];
  portalMaxHeight?: string;
  disconnectPortal: (id: number) => void;
  handleOpenClose?: () => void;
}
type Props = OwnProps;
const PortalLists: React.FC<Props> = ({
  currentPortalId = '',
  portals,
  handleOpenClose,
  disconnectPortal,
  portalMaxHeight = '400px',
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const redirectToDashboard = (portalId: number) => {
    navigate(ROOT_NAVIGATION.general.home(portalId.toString()));
    if (handleOpenClose) handleOpenClose();
  };

  return (
    <>
      {portals.map(portal => (
        <ListItem
          sx={{
            marginBottom: '15px',
            display: 'flex',
            padding: '20px 10px',
          }}
          button
          key={portal._id}
          className='shadow-md rounded-md shadow-slate-100 mt-5'
        >
          <ListItemText
            onClick={() => redirectToDashboard(portal.portal_id)}
            primary={portal.hub_domain}
            secondary={
              <>
                <Typography
                  sx={{ display: 'inline' }}
                  component='span'
                  variant='body2'
                  color='text.secondary'
                >
                  {t('id')} {portal.portal_id}
                </Typography>
              </>
            }
          />
          <Iconify
            icon='eva:trash-2-outline'
            onClick={() => disconnectPortal(portal.portal_id)}
          />
        </ListItem>
      ))}
    </>
  );
};
export default PortalLists;
